// Swiping down longer than MAX_SWIPE_DOWN_DISTANCE will not have more visual changes
export const MAX_SWIPE_DOWN_DISTANCE = 1500; // px

export const WIDGET_POSITIONS = [
  'topLeft',
  'topCenter',
  'topRight',
  'centerLeft',
  'centerCenter',
  'centerRight',
  'bottomLeft',
  'bottomCenter',
  'bottomRight',
  'top',
  'bottom'
];
// place large widgets those have multiple focusable elements at the end,
// so that keyboard users can get to their desired elements easier and faster.

export const WIDGET_POSITIONS_WITH_RTL = [
  'topRight',
  'topCenter',
  'topLeft',
  'centerRight',
  'centerCenter',
  'centerLeft',
  'bottomRight',
  'bottomCenter',
  'bottomLeft',
  'top',
  'bottom'
];
